import cn from 'classnames';

import { cexConfigs, dexConfigs, ECexName, IDexName } from 'web3';

interface IExchangeOptionProps {
  exchange: string;
  label: string;
  selected: boolean;
}

const ExchangeOption = ({ exchange, label, selected }: IExchangeOptionProps) => {
  const config = Object.values(ECexName).includes(exchange as ECexName)
    ? cexConfigs[exchange as ECexName]
    : dexConfigs[exchange as IDexName];

  return (
    <div className={cn('mm-select-exchange-field-item', { _selected: selected })}>
      {config?.icon && <img src={config.icon} className="exchange-image" />}
      <span>{label}</span>
    </div>
  );
};

export { ExchangeOption };
